"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataModels = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
__exportStar(require("./ApplicationInfo"), exports);
__exportStar(require("./Constants"), exports);
__exportStar(require("./Correlation"), exports);
__exportStar(require("./Cronjob/index"), exports);
__exportStar(require("./DataObjectInstance"), exports);
__exportStar(require("./ExternalTask/index"), exports);
__exportStar(require("./FlowNodeInstance/index"), exports);
__exportStar(require("./FlowNodeKpi"), exports);
__exportStar(require("./Iam/index"), exports);
__exportStar(require("./LogEntry"), exports);
__exportStar(require("./ProcessDefinition"), exports);
__exportStar(require("./ProcessInstance/index"), exports);
const correlation = require("./Correlation");
const cronjob = require("./Cronjob/index");
const dataObject = require("./DataObjectInstance");
const externalTasks = require("./ExternalTask/index");
const flowNodeInstances = require("./FlowNodeInstance/index");
const iam = require("./Iam/index");
const kpi = require("./FlowNodeKpi");
const logging = require("./LogEntry");
const processDefinitions = require("./ProcessDefinition");
const processInstances = require("./ProcessInstance/index");
var DataModels;
(function (DataModels) {
    DataModels.Correlation = correlation;
    DataModels.Cronjob = cronjob;
    DataModels.DataObjects = dataObject;
    DataModels.ExternalTasks = externalTasks;
    DataModels.FlowNodeInstances = flowNodeInstances;
    DataModels.Iam = iam;
    DataModels.Kpi = kpi;
    DataModels.Logging = logging;
    DataModels.ProcessDefinitions = processDefinitions;
    DataModels.ProcessInstances = processInstances;
})(DataModels = exports.DataModels || (exports.DataModels = {}));
//# sourceMappingURL=index.js.map